import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// ビルド時プリレンダ（Node）では window が無いため LanguageDetector を使わない
if (typeof window !== 'undefined') {
  i18n.use(LanguageDetector);
}
i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    // Locize 案内の console.info を抑止
    showSupportNotice: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;